



import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Line } from 'react-chartjs-2';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'chart.js/auto';
import './ReporteKpis.css';
import { DateRangePicker } from 'rsuite';
import isAfter from 'date-fns/isAfter';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import Modal from "react-modal";
import ModalAddHost from './ModalAddHost';
import { addHours, subHours, addDays, subDays, startOfWeek, endOfWeek, startOfMonth, endOfMonth, addMonths } from 'date-fns';
import LoadSimple from '../../LoadSimple';
const AddHosModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      background: "#ffffff !important",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "50%",
      height: "90%",
      padding: "20px",
    },
  };
const ReporteKpis = ({server,languaje,mode,hostsList,hostSelected,setHostSelected}) => {
  const [hostId, setHostId] = useState('');
  const [hosts, setHosts] = useState([]);
  const [kpis, setKpis] = useState([]);
  const [selectedKpi, setSelectedKpi] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [data, setData] = useState([]);
  const [average, setAverage] = useState(0);
  const [range, setRange] = useState([startOfMonth(new Date()), new Date()]);
  const [chartMessage, setChartMessage] = useState('Selecciones los datos correspondientes para mostrar la grafica'); // Mensaje del gráfico
  const [addHostModalOpen, setAddHostModalOpen] = useState(false);
  function closeAddHostModal() {
    setAddHostModalOpen(false);
  }
  const obtenerPrimerDiaDelMes = () => {
      const hoy = new Date();
      const primerDiaDelMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
      
      const anio = primerDiaDelMes.getFullYear();
      const mes = String(primerDiaDelMes.getMonth() + 1).padStart(2, '0');
      const dia = String(primerDiaDelMes.getDate()).padStart(2, '0');
      const horas = String(primerDiaDelMes.getHours()).padStart(2, '0');
      const minutos = String(primerDiaDelMes.getMinutes()).padStart(2, '0');
    
      return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
    };
  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, "0"); // El mes se cuenta desde 0
    const dia = String(ahora.getDate()).padStart(2, "0");
    const horas = String(ahora.getHours()).padStart(2, "0");
    const minutos = String(ahora.getMinutes()).padStart(2, "0");

    return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
  };
  const [opciones,setOpciones]=useState({fecha_ini:''+obtenerPrimerDiaDelMes(),fecha_fin:''+obtenerFechaActualLocal()})
  const formatDate=(date)=>{
      const anio = date.getFullYear();
      const mes = String(date.getMonth() + 1).padStart(2, '0');
        const dia = String(date.getDate()).padStart(2, '0');
        const horas = String(date.getHours()).padStart(2, '0');
        const minutos = String(date.getMinutes()).padStart(2, '0');
      // console.log(`${anio}-${mes}-${dia}T${horas}:${minutos}`)
      return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
    }
  useEffect(()=>{
      if(range!=null && range[0]!=null && range[1]!=null){
        setOpciones((prevState)=>{
     return {
         ...prevState,
         ['fecha_ini']:formatDate(range[0]),
         ['fecha_fin']:formatDate(range[1])
     }
    
 })
      }
      
   
    },[range])
  const predefinedRanges = [
      {
        label: 'Última hora',
        value: [subHours(new Date(), 1), new Date()],
        placement: 'left'
      },
      {
        label: 'Últimas 3 horas',
        value: [subHours(new Date(), 3), new Date()],
        placement: 'left'
      },
      {
        label: 'Últimas 6 horas',
        value: [subHours(new Date(), 6), new Date()],
        placement: 'left'
      },
      {
        label: 'Últimas 12 horas',
        value: [subHours(new Date(), 12), new Date()],
        placement: 'left'
      },
      {
        label: 'Últimas 24 horas',
        value: [subHours(new Date(), 24), new Date()],
        placement: 'left'
      },
      {
        label: 'Últimas 48 horas',
        value: [subHours(new Date(), 48), new Date()],
        placement: 'left'
      },
      {
        label: 'Esta semana',
        value: [startOfWeek(new Date()), new Date()],
        placement: 'left'
      },
      {
        label: 'Semana pasada',
        value: [subDays(new Date(), 6), new Date()],
        placement: 'left'
      },
      
      {
        label: 'Este mes',
        value: [startOfMonth(new Date()), new Date()],
        placement: 'left'
      },
      {
        label: 'Mes pasado',
        value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))],
        placement: 'left'
      },
      {
        label: 'Este año',
        value: [new Date(new Date().getFullYear(), 0, 1), new Date()],
        placement: 'left'
      },
      {
        label: 'Año pasado',
        value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear(), 0, 0)],
        placement: 'left'
      },
      
      
    ];
  const [loadingM,setLoadingM]=useState(false)
  const [dataM,setDataM]=useState([])
  // useEffect(()=>{
  //   buscar_metrica(hostSelected.id)
  // },[hostSelected])
  const buscar_metrica = (id) => {
    setLoadingM(true)
    setDataM([])
    const fetchDataPost = async () => {
      try {
        let baseURL=''
        baseURL = server.url+'/api/v1/cassia/kpis/by_host/'+id;
        // const user_email = (opciones.user_email=="")?'':'&user_email='+opciones.user_email
        // const module_id = (opciones.module_id=="")?'':'&module_id='+opciones.module_id

        const url=baseURL
        // console.log(url)  
        const response = await fetch(
          server.url+'/api/v1/cassia/kpis/by_host/'+id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );

        if (response.ok) {
          const data1 = await response.json();
          setLoadingM(false)
          setDataM(data1.data);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };
    if(hostSelected.hostid!=undefined){
      fetchDataPost();
    }
  };
  useEffect(() => {
    if (hostSelected.hostid && selectedKpi && opciones.fecha_ini && opciones.fecha_fin) {
        // fetchData();
        buscar_datos()
    }
  }, [hostId, selectedKpi, opciones]);
  const [loadHistoric,setLoadHistoric]=useState(false)
  const buscar_datos = (id) => {
    setLoadHistoric(true)
    const fetchDataPost = async () => {
      try {
        const data={
         "hostid": hostSelected.hostid,
         "kpi_id": selectedKpi,
         "start_time": opciones.fecha_ini.replace("T"," "),
         "end_time":opciones.fecha_fin.replace("T"," ")
        }


        // console.log(url)  
        const response = await fetch(
          server.url+'/api/v1/cassia/kpis/data/historicalKpi',
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
            body:JSON.stringify(data)
          }
        );

        if (response.ok) {
          const data1 = await response.json();
          setLoadHistoric(false)
          const formattedData = data1.data.map(entry => ({
              ...entry,
              timestamp: entry.timestamp.replace("T", " ")
          }));
          setData(formattedData);

          // Calcular el promedio de los valores
          const values = formattedData.map(entry => entry.value);
          const avg = values.reduce((sum, val) => sum + val, 0) / values.length;
          setAverage(avg.toFixed(2)); // Redondear a dos decimales
          setChartMessage(formattedData.length === 0 ? 'No data found' : '');
          // setDataM(data1.data);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setData([]);
          setChartMessage('No data found');
      } else {
          console.error('Error fetching historical KPI data:', error);
      }
        console.error(error);
      }
    };
    if(hostSelected.hostid!=undefined){
      fetchDataPost();
    }
  };
  const fetchData = async () => {
      try {
        const response = await axios.post(server.url+'/api/v1/cassia/kpis/data/historicalKpi', {
            hostid: parseInt(hostSelected.hostid, 10),
            kpi_id: parseInt(selectedKpi),
            // start_time: `${startDate.getFullYear()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getDate().toString().padStart(2, '0')} ${startDate.getHours().toString().padStart(2, '0')}:${startDate.getMinutes().toString().padStart(2, '0')}:${startDate.getSeconds().toString().padStart(2, '0')}`,
            // end_time: `${endDate.getFullYear()}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getDate().toString().padStart(2, '0')} ${endDate.getHours().toString().padStart(2, '0')}:${endDate.getMinutes().toString().padStart(2, '0')}:${endDate.getSeconds().toString().padStart(2, '0')}`,
            start_time:opciones.fecha_ini.replace("T"," "),
            end_time:opciones.fecha_fin.replace("T"," ")
        });
        const formattedData = response.data.map(entry => ({
            ...entry,
            timestamp: entry.timestamp.replace("T", " ")
        }));
        setData(formattedData);

        // Calcular el promedio de los valores
        const values = formattedData.map(entry => entry.value);
        const avg = values.reduce((sum, val) => sum + val, 0) / values.length;
        setAverage(avg.toFixed(2)); // Redondear a dos decimales
        setChartMessage(formattedData.length === 0 ? 'No data found' : ''); // Mensaje si no hay datos
      } catch (error) {
          if (error.response && error.response.status === 404) {
              setData([]);
              setChartMessage('No data found');
          } else {
              console.error('Error fetching historical KPI data:', error);
          }
      }
  };

  const handleHostChange = (e) => setHostId(e.target.value);
  const handleKpiChange = (e) =>{
    setSelectedKpi(e.target.value);
  };
  const handleStartDateChange = (date) => setStartDate(date);
  const handleEndDateChange = (date) => setEndDate(date);

  // Prepare data for the chart
  const chartData = {
      labels: data.map(entry => entry.timestamp),
      datasets: [
          {
              label: `KPI: ${selectedKpi?.kpi_name} | Promedio: ${average}`,
              data: data.map(entry => entry.value),
              fill: false,
              borderColor: '#1976D2',
              tension: 0.1,
          },
      ],
  };

  return (
      <>
      <div className="reporte-kpis-container" style={{ width: '80%', margin: '0 auto' }}>
          {/* <h1>Reporte de KPI</h1> */}
          <div className="contSearcgGraficKpi">
          <div className="form-group">
              <label className='labelGraficKpi'>{capitalizeFirstLetter(lang[languaje]['dispositivo'])}</label>
              <input className='inputGraficKpi' disabled value={(hostSelected.host==undefined)?'Seleccione un dispositivo':hostSelected.host}></input>
              <button className='butonGraficKpi' onClick={()=>setAddHostModalOpen(true)}>{capitalizeFirstLetter(lang[languaje]['agregar'])+" "+capitalizeFirstLetter(lang[languaje]['dispositivo']) }</button>
          </div>

          <div className="flex-container">
              <div className="form-group metric-select" style={{ flex: '1 1 40%' }}>
                  <label className='labelGraficKpi'>KPI:</label>
                  {
                    (loadingM)?'...':
                   (
                    (dataM.length==0)?<input className='inputGraficKpi' disabled value={(hostSelected.host==undefined)?'Seleccione un dispositivo':'cargando'}></input>:
                    <select  className='selectGraficKpi' value={selectedKpi} onChange={handleKpiChange}>
                    <option value="">Seleccione una opción</option>
                    {dataM.map((kpi) => (
                        <option key={kpi.id} value={kpi.id}>
                            {kpi.kpi_name}
                        </option>
                    ))}
                </select>
                   )
                  }
              </div>
              {/* <div className="form-group date-select" style={{ flex: '1 1 30%' }}>
                  <label>Fecha de Inicio:</label>
                  <DatePicker selected={startDate} onChange={handleStartDateChange} showTimeSelect dateFormat="Pp" />
              </div>*/}
              <div className="form-group date-select" style={{ flex: '1 1 30%' }}>
                  <label className='labelGraficKpi'>{capitalizeFirstLetter(lang[languaje]['rangoFechas'])}:</label>
                  <DateRangePicker
                      value={range}
                      ranges={predefinedRanges}
                      onChange={(value) => setRange(value)}
                      className="reporte-gs-datepicker"
                      placeholder="Seleccione un rango de fechas"
                      showOneCalendar={false} // Opcional: muestra solo un calendario
                      format="yyyy-MM-dd HH:mm" // Formato con horas
                      showMeridian // Si deseas mostrar el formato AM/PM
                      size='xs'
                      placement="leftStart"
                      shouldDisableDate={date => isAfter(date, new Date())}
              />
              </div> 
               {/* <div className='contSelectRangeDate' style={{left:'0%',position:'relative'}}>
          <div className="date-selector">
              
                  <DateRangePicker
                      value={range}
                      ranges={predefinedRanges}
                      onChange={(value) => setRange(value)}
                      className="reporte-gs-datepicker"
                      placeholder="Seleccione un rango de fechas"
                      showOneCalendar={false} // Opcional: muestra solo un calendario
                      format="yyyy-MM-dd HH:mm" // Formato con horas
                      showMeridian // Si deseas mostrar el formato AM/PM
                      size='xs'
                      placement="leftStart"
                      shouldDisableDate={date => isAfter(date, new Date())}
              />
          </div>
      </div> */}
          </div>
          </div>
          <div className="contSearcgGraficKpi">
          <div  className='contgrafMovil' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{ width: '80%' }}>
                  {(loadHistoric)?<LoadSimple></LoadSimple>:
                  (chartMessage ? (
                      <p style={{ textAlign: 'center', color: 'red', fontWeight: 'bold' }}>{chartMessage}</p>
                  ) : (
                      <Line data={chartData} />
                  ))}
              </div>
          </div>
      </div>
      </div>
      <Modal
      isOpen={addHostModalOpen}
      onRequestClose={closeAddHostModal}
      style={AddHosModalStyles}
      contentLabel="Example Modal2"
      shouldCloseOnOverlayClick={false}
    >
    <ModalAddHost
    hosts={hostsList} 
    setHostSelected={setHostSelected}
    server={server}
    languaje={languaje}
    mode={mode}
    hostSelected={hostSelected}
    closeAddHostModal={closeAddHostModal}
    buscar_metrica={buscar_metrica}
  ></ModalAddHost>
  </Modal>
  </>
 );
};

export default ReporteKpis;
